// Accounts that can see all payments and delete them
export const PAYMENT_ADMIN_EMAILS = [
	'cokten@milten.com.tr',
	'canakildev@gmail.com',
	'umutokten1@gmail.com',
];

export const isPaymentAdmin = (email) => PAYMENT_ADMIN_EMAILS.includes(email);
